<template>
  <div>
    <v-dialog
      v-model="internalValue"
      max-width="900px"
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card class="ds-dialog">
        <v-card-title class="ds-dialog-header" data-tour="cmd-header">
          <v-icon color="white" class="mr-2" style="position: relative; z-index: 1;">mdi-account-group</v-icon>
          <span class="ds-dialog-title">Médicos desta Clínica</span>
          <v-spacer />
          <v-btn icon color="white" aria-label="Ver tour" class="close-btn" @click="startTour">
            <v-icon>mdi-help-circle-outline</v-icon>
          </v-btn>
          <v-btn icon color="white" class="close-btn" @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="ds-dialog-body">
          <v-stepper v-model="step" flat class="transparent">
            <!-- STEPS HEADER -->
            <v-stepper-header class="steps-header" data-tour="cmd-steps">
              <v-stepper-step :complete="step > 1" step="1">
                Médicos Vinculados
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step step="2">
                {{ isEditMode ? "Editar Médico" : "Cadastrar Novo Médico" }}
              </v-stepper-step>
            </v-stepper-header>

            <!-- STEPS CONTENT -->
            <v-stepper-items>
              <!-- STEP 1: LISTA DE Médicos -->
              <v-stepper-content step="1" class="px-0 pb-0">
                <!-- Informações da clínica -->
                <section v-if="selectedClinicInfo" class="ds-form-section" data-tour="cmd-clinic-info">
                  <div class="ds-form-section__head">
                    <div class="ds-form-section__title">
                      <v-icon small color="primary" class="mr-2">mdi-hospital-building</v-icon>
                      <span>Clínica</span>
                    </div>
                  </div>
                  <div class="clinic-info-name">
                    {{ selectedClinicInfo.name }}
                  </div>
                  <div class="clinic-info-meta">
                    CNPJ: {{ selectedClinicInfo.cnpj }} -
                    {{ selectedClinicInfo.city }}/{{
                      selectedClinicInfo.state
                    }}
                  </div>
                </section>

                <section class="ds-form-section">
                  <div class="ds-form-section__head" data-tour="cmd-list">
                    <div class="ds-form-section__title">
                      <v-icon small color="primary" class="mr-2">mdi-account-tie</v-icon>
                      <span>Médicos Vinculados</span>
                    </div>
                    <span v-if="!loadingRelatedDoctors" class="ds-form-section__aside">{{ doctorsRelated.length }}</span>
                  </div>

                  <v-container fluid class="pa-0">
                    <v-row
                      v-if="loadingRelatedDoctors"
                      justify="center"
                      class="my-10"
                    >
                      <v-progress-circular
                        indeterminate
                        color="primary"
                        size="50"
                      ></v-progress-circular>
                    </v-row>

                    <v-row
                      v-if="!loadingRelatedDoctors && doctorsRelated.length"
                      dense
                    >
                      <v-col
                        v-for="(doctor, i) in doctorsRelated"
                        :key="doctor.id"
                        cols="12"
                        sm="6"
                        md="4"
                      >
                        <v-card
                          outlined
                          class="doctor-card h-100"
                          hover
                          :data-tour="i === 0 ? 'cmd-doctor-card' : null"
                        >
                          <v-card-title class="pa-3 flex-nowrap align-start">
                            <v-avatar size="50" class="mr-3 flex-shrink-0">
                              <v-img :src="doctor.imageUrl" />
                            </v-avatar>
                            <div class="flex-grow-1" style="min-width: 0">
                              <div
                                class="font-weight-medium text-caption text-truncate"
                                :title="doctor.name"
                              >
                                {{ doctor.name }}
                              </div>
                              <div
                                class="text-caption grey--text text-truncate"
                                :title="doctor.email"
                              >
                                {{ doctor.email }}
                              </div>
                              <div
                                class="text-caption grey--text text-truncate"
                                v-if="doctor.cpf"
                              >
                                CPF: {{ doctor.cpf }}
                              </div>
                            </div>
                          </v-card-title>

                          <!-- AÇÕES -->
                          <v-card-actions
                            class="pa-3 pt-0"
                            :data-tour="i === 0 ? 'cmd-actions' : null"
                          >
                            <v-btn
                              icon
                              color="primary"
                              @click="editDoctor(doctor)"
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn
                              icon
                              color="red"
                              @click="openDeleteDialog(doctor)"
                            >
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-col>
                    </v-row>

                    <div
                      v-else-if="!loadingRelatedDoctors"
                      class="text-center py-6"
                    >
                      <v-icon size="64" color="#C2DDD3" class="mb-3">
                        mdi-account-heart
                      </v-icon>
                      <div class="empty-state-title mb-2">
                        Nenhum Médico vinculado
                      </div>
                      <div class="empty-state-subtitle">
                        Esta clínica ainda não possui Médicos vinculados
                      </div>
                    </div>
                  </v-container>

                  <div class="mt-4 text-right" data-tour="cmd-new">
                    <v-btn color="primary" depressed @click="goToStep2()">
                      <v-icon left>mdi-plus</v-icon>
                      Novo Médico
                    </v-btn>
                  </div>
                </section>
              </v-stepper-content>

              <!-- STEP 2: CADASTRAR Médico -->
              <v-stepper-content step="2" class="px-0 pb-0">
                <section class="ds-form-section">
                  <div class="ds-form-section__head">
                    <div class="ds-form-section__title">
                      <v-icon small color="primary" class="mr-2">mdi-account-plus</v-icon>
                      <span>Cadastrar Médico</span>
                    </div>
                  </div>

                  <v-form ref="doctorForm" v-model="formValido">
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="doctor.email"
                          label="Email"
                          prepend-inner-icon="mdi-email-outline"
                          clearable
                          outlined
                          color="primary"
                          type="email"
                          :rules="[
                            (v) => !!v || 'Email obrigatório',
                            (v) => /.+@.+\..+/.test(v) || 'Email inválido',
                          ]"
                        />
                      </v-col>
                    </v-row>
                  </v-form>

                  <div class="d-flex align-center mt-4">
                    <v-btn
                      outlined
                      color="primary"
                      @click="step = 1"
                    >
                      <v-icon left>mdi-close</v-icon>
                      Cancelar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      :loading="loading"
                      dark
                      depressed
                      @click="saveDoctor"
                    >
                      <v-icon left>mdi-content-save</v-icon>
                      Salvar
                    </v-btn>
                  </div>
                </section>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import http from "@/services/http";
import { useSnackbar } from "@/composables/useSnackbar";
import { getMyClinics, getDoctorsByClinics } from "@/services/clinicService";
import { getProfileImage } from "@/utils/getProfileImage";
import tourDialogMixin from "@/features/tour/tourDialogMixin";

export default {
  name: "CheckMyClinicDoctorsDialog",

  mixins: [tourDialogMixin],

  props: {
    value: { type: Boolean, default: false },
    clinicId: { type: Number, default: null },
  },

  setup() {
    const { success, error, warning, info, erroDeRequisicao } = useSnackbar();
    return { success, error, warning, info, erroDeRequisicao };
  },

  data() {
    return {
      // dialog / stepper
      dialogVisible: false,
      step: 1,

      // clinic
      clinics: [],
      selectedClinicId: null,
      selectedClinicInfo: null,

      // doctors list
      doctorsRelated: [],
      loadingRelatedDoctors: false,

      // form
      formValido: false,
      loading: false,
      erro: "",
      doctor: {
        email: "",
        clinic_id: null,
      },

      // edit mode
      isEditMode: false,
      editingDoctorId: null,

      // delete confirm dialog
      doctorToDelete: null,
      loadingDelete: false,

      // ✅ guarda blob urls (para revogar)
      _doctorBlobUrls: new Set(),
    };
  },

  computed: {
    userType() {
      return this.$store.getters["auth/userType"];
    },
    me() {
      return this.$store.getters["auth/user"];
    },

    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },

    tourId() {
      return "dialog-medicos-clinica";
    },
  },

  watch: {
    value(val) {
      if (val) {
        this.initDialog();
        this.tourOnOpen();
      }
    },
  },

  async mounted() {
    await this.$store.dispatch("auth/ensureAuth");
    await this.fetchClinics();
  },

  beforeDestroy() {
    this.revokeDoctorBlobs();
  },

  methods: {
    // ================= TOUR =================
    tourReady() {
      return !this.loadingRelatedDoctors;
    },

    tourSteps() {
      return [
        {
          title: "Médicos da Clínica",
          description:
            "Aqui você gerencia todos os médicos vinculados a esta clínica. Vou te mostrar rapidinho como tudo funciona.",
        },
        {
          anchor: "cmd-header",
          title: "Cabeçalho",
          description:
            "Este é o topo do diálogo. O botão de interrogação reabre este tour e o X fecha a janela quando quiser.",
        },
        {
          anchor: "cmd-steps",
          title: "Etapas",
          description:
            "O fluxo tem duas etapas: a lista de médicos vinculados e o cadastro de um novo médico. Você pode acompanhar em qual etapa está por aqui.",
        },
        {
          anchor: "cmd-clinic-info",
          title: "Dados da Clínica",
          description:
            "Este cartão mostra o nome, CNPJ e cidade da clínica que você está visualizando, para não haver dúvida sobre onde os médicos estão sendo vinculados.",
        },
        {
          anchor: "cmd-list",
          title: "Médicos Vinculados",
          description:
            "Abaixo desta seção ficam listados todos os médicos já vinculados a esta clínica.",
        },
        {
          anchor: "cmd-doctor-card",
          title: "Cartão do Médico",
          description:
            "Cada médico aparece em um cartão com foto, nome, e-mail e CPF. Assim fica fácil identificar cada profissional.",
        },
        {
          anchor: "cmd-actions",
          title: "Ações do Médico",
          description:
            "No cartão você pode editar os dados do médico pelo lápis ou remover o vínculo dele com a clínica pela lixeira.",
        },
        {
          anchor: "cmd-new",
          title: "Cadastrar Novo Médico",
          description:
            "Use este botão para convidar e vincular um novo médico à clínica informando o e-mail dele. Pronto, você já conhece a tela!",
        },
      ];
    },

    // ================= CLÍNICAS =================
    async fetchClinics() {
      try {
        this.clinics = (await getMyClinics()) || [];
      } catch (err) {
        console.error("Erro ao buscar clínicas:", err);
        this.erroDeRequisicao(err, "Erro ao carregar clínicas");
        this.clinics = [];
      }
    },

    async initDialog() {
      this.selectedClinicId = this.clinicId;
      this.step = 1;
      this.selectedClinicInfo =
        this.clinics.find((c) => c.id === this.clinicId) || null;

      await this.fetchRelatedDoctors();
    },

    // ================= LISTAGEM =================
    async fetchRelatedDoctors() {
      if (!this.selectedClinicId) return;

      this.loadingRelatedDoctors = true;

      // ✅ evita leak ao recarregar lista
      this.revokeDoctorBlobs();

      try {
        const doctors =
          (await getDoctorsByClinics(this.selectedClinicId)) || [];

        this.doctorsRelated = await Promise.all(
          doctors.map(async (doc) => {
            const imageUrl = await getProfileImage(doc.profile_image);

            // ✅ se for blob:, guarda pra revogar depois
            if (typeof imageUrl === "string" && imageUrl.startsWith("blob:")) {
              // blindagem extra
              if (!this._doctorBlobUrls) this._doctorBlobUrls = new Set();
              this._doctorBlobUrls.add(imageUrl);
            }

            return { ...doc, imageUrl };
          }),
        );
      } catch (err) {
        console.error("Erro ao buscar Médicos:", err);
        this.erroDeRequisicao(err, "Erro ao carregar Médicos da clínica");
        this.doctorsRelated = [];
      } finally {
        this.loadingRelatedDoctors = false;
      }
    },

    revokeDoctorBlobs() {
      if (!this._doctorBlobUrls) {
        this._doctorBlobUrls = new Set();
        return;
      }

      for (const url of this._doctorBlobUrls) {
        try {
          URL.revokeObjectURL(url);
        } catch {}
      }
      this._doctorBlobUrls.clear();
    },

    // ================= STEPS =================
    goToStep2() {
      this.resetDoctorForm();
      this.isEditMode = false;
      this.editingDoctorId = null;
      this.step = 2;
    },

    async editDoctor(doctor) {
      this.isEditMode = true;
      this.editingDoctorId = doctor.id;
      await this.loadDoctor(doctor.id);
      this.step = 2;
    },

    // ================= EXCLUSÃO =================
    async openDeleteDialog(doctor) {
      this.doctorToDelete = doctor;
      const ok = await this.$confirm({
        type: "delete",
        title: "Confirmar exclusão",
        message: `Tem certeza que deseja excluir este médico?\n${doctor?.name || ""}${doctor?.email ? " - " + doctor.email : ""}`,
        hint: "Esta ação não pode ser desfeita.",
      });
      if (!ok) {
        this.doctorToDelete = null;
        return;
      }
      await this.deleteDoctor(doctor.id);
    },

    async deleteDoctor(id) {
      this.loadingDelete = true;

      try {
        await http.delete(`/api/doctors/delete/${id}`);
        this.success("Médico deletado!");
        await this.fetchRelatedDoctors();
      } catch (err) {
        console.error(err);
        this.erroDeRequisicao(err, "Erro ao deletar Médico");
      } finally {
        this.loadingDelete = false;
        this.doctorToDelete = null;
      }
    },

    // ================= FORM =================
    resetDoctorForm() {
      this.doctor = { email: "", clinic_id: null };
      this.erro = "";
      this.loading = false;
      this.editingDoctorId = null;
      this.isEditMode = false;

      this.$nextTick(() => {
        this.$refs.doctorForm?.resetValidation?.();
      });
    },

    async loadDoctor(id) {
      try {
        const { data } = await http.get(`/api/user/get-user/${id}`);
        const doctorData = data?.data || data;

        if (!doctorData) throw new Error("Dados do Médico não encontrados");

        this.doctor = {
          email: doctorData.email || "",
          clinic_id: doctorData.clinic_id || this.selectedClinicId,
        };
      } catch (err) {
        console.error("Erro ao carregar Médico:", err);
        this.erroDeRequisicao(err, "Erro ao carregar dados do Médico.");
      }
    },

    async saveDoctor() {
      const valido = this.$refs.doctorForm?.validate?.();
      if (!valido) return this.error("Por favor, informe um email válido.");
      if (!this.selectedClinicId) return this.error("Selecione uma clínica.");

      this.loading = true;

      try {
        await http.post(`/api/clinics/invite-user/${this.selectedClinicId}`, {
          email: this.doctor.email,
          role_id: 1,
        });

        this.success("Médico cadastrado com sucesso!");
        await this.fetchRelatedDoctors();
        this.step = 1;
        this.resetDoctorForm();
      } catch (err) {
        if (err.response?.status === 422) {
          const errors = err.response.data?.errors;
          const msg = errors
            ? Object.values(errors)[0]?.[0] || "Erro de validação."
            : "Erro de validação.";
          this.erroDeRequisicao(err, msg);
        } else {
          this.erroDeRequisicao(err, "Erro ao salvar Médico.");
        }
      } finally {
        this.loading = false;
      }
    },

    // ================= UI =================
    closeDialog() {
      this.$emit("input", false);
      this.dialogVisible = false;
      this.selectedClinicId = null;
      this.selectedClinicInfo = null;
      this.doctorsRelated = [];
      this.step = 1;
      this.resetDoctorForm();
      this.revokeDoctorBlobs();
    },
  },
};
</script>

<style scoped>
/* ═══ Design system dialog ═══ */
.ds-dialog {
  border-radius: 4px !important;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(31, 77, 63, 0.18),
    0 4px 12px rgba(0, 0, 0, 0.06) !important;
}

.ds-dialog-header--danger {
  background: linear-gradient(135deg, var(--ds-danger) 0%, var(--ds-danger-mid) 60%, var(--ds-danger-light) 100%) !important;
}

.close-btn {
  position: relative;
  z-index: 1;
}

.close-btn:hover {
  background-color: rgba(255, 255, 255, 0.15) !important;
}

/* ═══ Cabeçalho do stepper: cartão branco sobre o corpo areia ═══ */
.steps-header {
  background: var(--ds-surface-white);
  border: 1px solid var(--ds-blue-100);
  border-radius: var(--ds-radius);
  box-shadow: none !important;
}

/* ═══ Info da clínica ═══ */
.clinic-info-name {
  font-size: 14px;
  font-weight: 700;
  color: var(--ds-text-strong);
  letter-spacing: -0.2px;
}

.clinic-info-meta {
  font-size: 11px;
  color: var(--ds-primary);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-top: 2px;
}

/* ═══ Doctor card ═══ */
.doctor-card {
  border-radius: 12px !important;
  border: 1px solid var(--ds-blue-100) !important;
  box-shadow: 0 2px 8px rgba(31, 77, 63, 0.04) !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.doctor-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(31, 77, 63, 0.16) !important;
  border-color: var(--ds-blue-200) !important;
}

.doctor-card :deep(.v-avatar) {
  border: 2px solid var(--ds-blue-100);
}

.doctor-card :deep(.font-weight-medium) {
  font-size: 13px;
  color: var(--ds-text-strong);
  font-weight: 700 !important;
}

/* ═══ Empty state ═══ */
.empty-state-title {
  font-size: 16px;
  font-weight: 700;
  color: var(--ds-primary);
  letter-spacing: -0.2px;
}

.empty-state-subtitle {
  font-size: 12px;
  color: var(--ds-text-soft);
  font-weight: 500;
  line-height: 1.5;
}
</style>
